import Icon from '../components/Icon.vue'

Icon.register({
  'fighter-jet': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M544 224c96 21.3 96 26.6 96 32s0 10.7-96 32l-128 16-48 16h-24l-116.8 148h39.5c11.7 0 21.3 2.6 21.3 6s-9.7 6-21.3 6h-114.7v-12h16v-164h-48l-66.7 80h-34.7l-10.7-10.7v-69.3h8v-16h48v-2.7l-64-8v-42.7l64-8v-2.7h-48v-16h-8v-69.3l10.7-10.7h34.7l66.7 80h48v-164h-16v-12h114.7c11.7 0 21.3 2.6 21.3 6s-9.7 6-21.3 6h-39.5l116.8 148h24l48 16z'
      }
    ]
  }
})
